import { render } from "./AppButton.vue?vue&type=template&id=2cb8bdc3&scoped=true"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=2cb8bdc3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb8bdc3"]])

export default __exports__